import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

const classnames = require('classnames');

export default function LayoutCell(props: {
    dragScope;
    x: number;
    y: number;
    occupied;
    shiftY: number;
    addTitle: string;
    colObj: {
        size?: number;
    };

    onDrop(payload, x: number, y: number): void;
    onAdd(x: number, y: number): void;
}) {
    const containerRef = React.useRef(null);

    React.useEffect(() => {
        const handleOnDrop = (e, ui) => {
            const payload = $(ui.draggable).data('payload');

            if (typeof props.onDrop === 'function') {
                props.onDrop(payload, props.x, props.y);
            }
        };

        $(containerRef.current).droppable({
            hoverClass: 'hover',
            activeClass: 'active',
            tolerance: 'pointer',
            scope: props.dragScope,
            drop: handleOnDrop
        });

        // $(refs['hidden-input']).on('paste', function (e) {
        //     console.log(e);
        // });

        return () => {
            $(containerRef.current).droppable('destroy');
        };
    }); //EVG: See Issue 87842. droppable must be always resubscribed to make onDrop() have a new context.

    const handleOnAddElement = (e) => {
        if (typeof props.onAdd === 'function') {
            props.onAdd(props.x, props.y);
        }
    };

    const classes = classnames({
        'layout-cell': true,
        occupied: props.occupied
    });

    return (
        <div
            ref={containerRef}
            className={classes}
            style={{
                width: props.colObj.size,
                left: props.shiftY
            }}
        >
            <div className="layout-empty"></div>

            <div className="drop-message">
                <div>{'Drop here'}</div>
            </div>

            <div className="add-button" onClick={handleOnAddElement}>
                <span className="add-icon glyphicon glyphicon-plus"></span>
                <span className="add-title">{props.addTitle || 'New widget'}</span>
            </div>
        </div>
    );
}
